// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__VeU28","productName":"Table_productName__3oVlw"};